import { render, staticRenderFns } from "./ConfigurationNavigation.vue?vue&type=template&id=32957835"
import script from "./ConfigurationNavigation.vue?vue&type=script&lang=js"
export * from "./ConfigurationNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports